if (!customElements.get('product-form-validation')) {
  customElements.define(
    'product-form-validation',
    class ProductFormValidation extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.dynamicCheckoutButton = this.querySelector('.shopify-payment-button');
        this.requiredInputs = this.querySelectorAll('input[required]');
        this.requiredRadioGroups = this.getRequiredRadioGroups();
        
        if (this.form) {
          this.form.addEventListener('submit', this.validateForm.bind(this));
          this.setupInputListeners();
          this.loadSavedValues();
        }
      }
      
      getRequiredRadioGroups() {
        const radioInputs = this.querySelectorAll('input[type="radio"][required]');
        const groups = new Map();
        
        radioInputs.forEach(radio => {
          const name = radio.name;
          if (!groups.has(name)) {
            groups.set(name, Array.from(this.querySelectorAll(`input[type="radio"][name="${name}"]`)));
          }
        });
        
        return groups;
      }
      
      setupInputListeners() {
        this.requiredInputs.forEach(input => {
          input.addEventListener('input', this.handleInputChange.bind(this));
          input.addEventListener('change', this.handleInputChange.bind(this));
        });
        
        // Add listeners for radio buttons
        this.requiredRadioGroups.forEach(radios => {
          radios.forEach(radio => {
            radio.addEventListener('change', this.handleInputChange.bind(this));
            // Add touchstart for better mobile responsiveness
            radio.addEventListener('touchstart', () => {
              // Small delay to ensure the radio is actually checked before validation
              setTimeout(() => this.handleInputChange({target: radio}), 10);
            }, {passive: true});
          });
        });
        
        // Initial check
        this.checkFormValidity();
      }
      
      handleInputChange(event) {
        const input = event.target;
        
        // Save value to localStorage (only for text inputs)
        if (input.id && input.type !== 'radio') {
          localStorage.setItem(`shopify_form_${input.id}`, input.value);
          
          // If this is a visible field with a corresponding hidden field
          const hiddenField = document.getElementById(`${input.id}_hidden`);
          if (hiddenField) {
            hiddenField.value = input.value;
          }
        }
        
        // For radio buttons, save the selected value
        if (input.type === 'radio' && input.checked) {
          localStorage.setItem(`shopify_form_radio_${input.name}`, input.value);

          // If this radio group has a corresponding hidden field
          const radioGroupName = input.name.replace(/attributes\[(.*?)\]/, '$1');
          const hiddenRadioField = document.getElementById(`field_${radioGroupName}_hidden`);
          if (hiddenRadioField) {
            hiddenRadioField.value = input.value;
          }
        }
        
        this.checkFormValidity();
      }
      
      loadSavedValues() {
        this.requiredInputs.forEach(input => {
          if (input.id && input.type !== 'radio') {
            const savedValue = localStorage.getItem(`shopify_form_${input.id}`);
            if (savedValue) {
              input.value = savedValue;
              
              // If this is a visible field with a corresponding hidden field
              const hiddenField = document.getElementById(`${input.id}_hidden`);
              if (hiddenField) {
                hiddenField.value = savedValue;
              }
            }
          }
        });
        
        // Load saved radio button selections
        this.requiredRadioGroups.forEach((radios, name) => {
          const savedValue = localStorage.getItem(`shopify_form_radio_${name}`);
          if (savedValue) {
            const radioToCheck = radios.find(radio => radio.value === savedValue);
            if (radioToCheck) {
              radioToCheck.checked = true;
              const radioGroupName = radioToCheck.name.replace(/attributes\[(.*?)\]/, '$1');
              const hiddenRadioField = document.getElementById(`field_${radioGroupName}_hidden`);
              if (hiddenRadioField) {
                hiddenRadioField.value = radioToCheck.value;
              }
            }
          }
        });
        
        // Check validity after loading values
        this.checkFormValidity();
      }
      
      checkFormValidity() {
        let isValid = true;
        
        // Check text inputs
        this.requiredInputs.forEach(input => {
          if (input.type !== 'radio' && !input.value.trim()) {
            isValid = false;
          }
        });
        
        // Check radio groups
        this.requiredRadioGroups.forEach((radios, name) => {
          const isRadioGroupValid = radios.some(radio => radio.checked);
          if (!isRadioGroupValid) {
            isValid = false;
          }
        });
        if (this.submitButton) {
          if (isValid) {
            this.submitButton.removeAttribute('disabled');
            if (this.dynamicCheckoutButton) {
              this.dynamicCheckoutButton.style.display = 'block';
            }
          } else {
            this.submitButton.setAttribute('disabled', true);
            if (this.dynamicCheckoutButton) {
              this.dynamicCheckoutButton.style.display = 'none';
            }
          }
        }

      }
      
      validateForm(event) {
        let isValid = true;
        
        // Validate text inputs
        this.requiredInputs.forEach(input => {
          if (input.type !== 'radio' && !input.value.trim()) {
            event.preventDefault();
            input.classList.add('error');
            isValid = false;
          } else {
            input.classList.remove('error');
          }
        });
        
        // Validate radio groups
        this.requiredRadioGroups.forEach((radios, name) => {
          const isRadioGroupValid = radios.some(radio => radio.checked);
          if (!isRadioGroupValid) {
            event.preventDefault();
            radios.forEach(radio => {
              radio.closest('.field__radio-option').classList.add('error');
            });
            isValid = false;
          } else {
            radios.forEach(radio => {
              radio.closest('.field__radio-option').classList.remove('error');
            });
          }
        });
        
        if (!isValid) {
          const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const errorMessage = this.querySelector('.product-form__error-message');
          
          if (errorWrapper && errorMessage) {
            errorWrapper.removeAttribute('hidden');
            errorMessage.textContent = window.variantStrings?.requiredFields || 'Please fill in all required fields';
          }
        }
        
        return isValid;
      }
    }
  );
}